import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
export var EventManager = (function () {
    function EventManager() {
        var _this = this;
        this.observable = Observable.create(function (observer) {
            _this.observer = observer;
        }).share();
    }
    EventManager.prototype.broadcast = function (event) {
        this.observer.next(event);
    };
    EventManager.prototype.subscribe = function (eventName, callback) {
        return this.observable.filter(function (event) {
            return event.name === eventName;
        }).subscribe(callback);
    };
    EventManager.prototype.destroy = function (subscriber) {
        subscriber.unsubscribe();
    };
    EventManager.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    EventManager.ctorParameters = function () { return []; };
    return EventManager;
}());
//# sourceMappingURL=event.manager.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-stormpath/dist/esm/src/stormpath/event.manager.js
// module id = 574
// module chunks = 0